import styled from 'styled-components'

export const SurveyContainer = styled.div`
	height: auto;
	position: relative;
	left: 0;
	animation: fadeSlide 0.4s;

	@keyframes fadeSlide {
		0% {
			left: -70px;
			opacity: 0;
		}
		100% {
			opacity: 1;
			left: 0;
		}
	}
`

export const LogoBrands = styled.div`
	display: grid;
	grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
`

export const CompanyBrand = styled.div`
	img {
		height: 100px;
	}
`

export const Title = styled.div<{ fontWeight: number }>`
	max-width: 390px;
	width: 100%;
	margin: 20px 0;
	font-weight: ${({ fontWeight }) => fontWeight};
`

export const PresentationContainer = styled.div`
	display: grid;
	place-items: center;
	margin: 15px 0;

	img {
		max-width: 300px;
	}

	@media screen and (min-width: 576px) {
		margin: 65px 0;
	}

	@media screen and (min-width: 768px) {
		margin: 65px 0;
	}

	@media screen and (min-width: 992px) {
		margin: 65px 0;
	}
`

export const ActionContainer = styled.div`
	display: grid;
	place-items: center;
	padding-bottom: 20px;
	max-width: 260px;
	margin: 0 auto;
`

export const BoldText = styled.span`
	font-weight: bold;
`

export const AcceptanceContainer = styled.div`
	display: grid;
	grid-template-columns: 30px 1fr;
	max-width: 390px;
	width: 100%;
	gap: 10px;
	margin: 20px 0;
	font-style: normal;
	font-weight: 500;
	font-size: 12px;
	line-height: 20px;
	color: #64778f;

	.checkbox-before {
		height: 24px;
	}
`
